export const ROOT_URL =
    process.env.REACT_APP_ENV === "production"
        ? "https://api.lem-riverdi.pl" :
        process.env.REACT_APP_ENV === "staging" ?
            "https://api-staging.lem-riverdi.pl"
    : "http://localhost:3090";

export const headers = {
  authorization: localStorage.getItem("token") || "no token",
};

export const itemsPerPage = 20;
